import { Link } from 'react-router-dom';
import LicenseInfo from './LicenseInfo';
import TeamsConfig from './TeamsConfig';
import HybridConfig from './HybridConfig';
// import { useData } from '../util/dataContext';
import { useAuth } from '../hooks/useAuth';

function Licenses() {
  const data = useAuth();

  if (!data || !data.tenant) {
    return null;
  }

  return (
    <>
      <hr />
      <LicenseInfo />
      <p />
      <TeamsConfig />
      <HybridConfig />
      <hr />
      <br />
      <Link to="/activate-license">Activate New License</Link>
    </>
  );
}

export default Licenses;
